<template>
  <div class="page-detail  licence-detail" :class="[`page-${pageType}`]">
    <div class="account-card">
      <div class="account-card-header">
        <h4 class="account-card-title">资质证照</h4>
      </div>
      <div class="account-card-body">
        <el-form
          ref="detailForm"
          :model="detailForm"
          label-width="130px"
          :rules="detailFormRules"
          inline
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="证照名称：" prop="licenceId">
                <el-select v-model="detailForm.licenceId" placeholder="请选择">
                  <el-option
                    v-for="item in licenseList"
                    :key="item.licenceId"
                    :label="item.licenceName"
                    :value="item.licenceId"
                  >
                  </el-option>
                </el-select>
                <span class="form-item-text">
                  <span v-if="detailForm.licenceFrom != 1">{{
                    licenseList.reduce(
                      (s, o) =>
                        o.licenceId == detailForm.licenceId ? o.licenceName : s,
                      ''
                    )
                  }}</span>
                  <span v-else>{{ detailForm.licenceName }}</span>
                </span>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="证照名称：" prop="licenceName">
                <el-input v-model="detailForm.licenceName"></el-input>
                <span class="form-item-text">{{ detailForm.licenceName }}</span>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="12">
              <el-form-item label="证照编号：" prop="licenceCode">
                <el-input v-model="detailForm.licenceCode"></el-input>
                <span class="form-item-text">{{ detailForm.licenceCode }}</span>
              </el-form-item>
            </el-col> -->
            <el-col :span="24">
              <el-col :span="12">
                <el-form-item
                  v-show="!isDialogPicker"
                  label="证照有效期至："
                  prop="islicenceEndTime"
                >
                  <el-date-picker
                    v-model="detailForm.licenceEndTime"
                    :disabled="true"
                    type="date"
                    value-format="yyyy-MM-dd"
                    @change="changePicker(detailForm.licenceEndTime)"
                  ></el-date-picker>
                  <span class="form-item-text">
                    {{
                      detailForm.isLongValid == 1
                        ? '长期有效'
                        : detailForm.licenceEndTime
                    }}
                  </span>
                </el-form-item>
                <el-form-item
                  label="证照有效期至："
                  prop="licenceEndTime"
                  v-show="isDialogPicker"
                  v-if="isDialogPicker"
                  :rules="[
                    { required: true, message: '请选择', trigger: 'blur' }
                  ]"
                >
                  <el-date-picker
                    v-model="detailForm.licenceEndTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    @change="changePicker(detailForm.licenceEndTime)"
                  ></el-date-picker>
                  <span class="form-item-text">
                    {{ detailForm.licenceEndTime }}
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-checkbox
                    v-model="detailForm.isLongValid"
                    :true-label="1"
                    :false-label="0"
                    :disabled="isLongValid"
                    @change="chooseIsLongValid"
                    >长期有效</el-checkbox
                  >
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-upload
                action=""
                accept=".jpg, .jpeg, .png, .bmp"
                :http-request="httpRequest"
                :before-upload="beforeUpload"
                :show-file-list="false"
              >
                <!-- :limit="1" -->
                <!-- :auto-upload="false" -->
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  <dl class="upload-tip">
                    <dt>上传提示：</dt>
                    <dd>1.图片文件大小限制 20MB</dd>
                    <dd>2.图片尺寸最大2000*2000像素，最小600*600像素</dd>
                    <dd>3.允许文件类型：jpg.jpeg.bmp.png</dd>
                    <dd>4.请上传原件彩色扫描正面图片</dd>
                  </dl>
                </div>
              </el-upload>
              <div class="file-preview">
                <div v-if="file">
                  <!-- <div v-if="file.type">
                    {{ file.name }}
                  </div> -->
                  <div>
                    <img :src="file.src" alt="" />
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <div class="button-group">
            <el-button
              type="primary"
              size="medium"
              @click="onCreate"
              v-if="pageType !== 'check'"
            >
              确定
            </el-button>
            <el-button size="medium" @click="onCancel">取消</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config'
export default {
  name: 'LicenceDetail',
  components: {},
  directives: {},
  filters: {},
  mixins: {},
  props: {
    propName: {
      // type: number,
      // default: 0
    }
  },
  data() {
    return {
      licenseList: [],
      isDialogPicker: true,
      isLongValid: false, //默认可选择长期有效
      fileList: [],

      file: {
        data: '',
        src: ''
      },
      detailForm: {
        licenceEndTime: '',
        isLongValid: 0,
        fileId: '',
        licenceId: ''
      },
      detailFormRules: {
        licenceName: [{ required: true, message: '请输入', trigger: 'blur' }],
        licenceCode: [{ required: true, message: '请输入', trigger: 'blur' }],
        licenceId: [{ required: true, message: '请选择', trigger: 'change' }]
        // licenceEndTime: [{ required: true, message: '请输入', trigger: 'blur' }]
      }
    }
  },
  computed: {
    pageType() {
      return this.$route.query.pageType
    }
  },
  watch: {},
  created() {
    if (this.pageType !== 'create' && this.$route.query.id) {
      this.getLicenceItem()
    }
    // 资质证照
    if (this.pageType === 'check' && !this.$route.query.id) {
      this.detailForm = Object.assign({}, this.$route.query)
      this.file.src = this.detailForm.imageUrl
      if (this.detailForm.isLongValid == 1) {
        this.isDialogPicker = false
        this.detailForm.licenceEndTime = ''
      } else {
        this.isLongValid = true
      }
    }
    this.getClassCode()
  },
  methods: {
    async getLicenceItem() {
      let params = this.$route.query.id
      let data = await this.$api.licence.getLicenceItem(params)
      if (data.isLongValid == 1) {
        this.isDialogPicker = false
        data.licenceEndTime = ''
      } else {
        this.isLongValid = true
      }
      this.detailForm = Object.assign({}, data)
      this.file.src = config.STATIC_URL + this.detailForm.imageUrl
    },
    async getClassCode() {
      this.licenseList = await this.$api.materialdisposal.licenceAll()
    },
    beforeUpload(file) {
      let reg = /\.(jpg|JPG|png|PNG|BMP|bmp|JPEG|jpeg)$/
      const isJPG = reg.test(file.name)
      const isLt2M = file.size / 1024 / 1024 < 20
      if (!isJPG) {
        this.$message.error('上传图片格式有误!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过20M!')
      }
      return isJPG && isLt2M
    },
    httpRequest(params) {
      // if (!this.beforeUpload) return
      this.file.data = params.file
      this.file.type = params.file.type.indexOf('pdf') > 0
      // console.log(params.file.type.indexOf('pdf'), 876)
      this.file.name = params.file.name
      let fileReader = new FileReader()
      fileReader.readAsDataURL(this.file.data)
      fileReader.onload = () => {
        let img = new Image()
        let src = fileReader.result
        img.src = src
        img.onload = () => {
          console.log(img.naturalHeight)
          console.log(img.naturalWidth)

          this.file.src = src
        }
      }
    },
    //修改时间选择框
    changePicker(val) {
      this.isLongValid =
        Boolean(val) && this.detailForm.licenceEndTime !== '2099-12-31'
    },
    //勾选长期有效
    chooseIsLongValid(val) {
      this.isDialogPicker = !val
      if (this.detailForm.licenceEndTime) {
        this.detailForm.licenceEndTime =
          this.detailForm.licenceEndTime === '2099-12-31'
            ? null
            : this.detailForm.licenceEndTime
      }
      if (this.detailFormRules.licenceEndTime) {
        this.detailFormRules.licenceEndTime[0].required = !val
      }
    },
    onCreate() {
      this.$refs.detailForm.validate(async valid => {
        if (valid) {
          if (this.pageType === 'create') {
            if (!this.file.data) {
              this.$message.error('请按要求上传附件!')
            } else {
              let form = new FormData()
              form.append('file', this.file.data)
              const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              })
              let fileData = await this.$api.common.fileUpload(form)
              loading.close()
              this.detailForm.fileId = fileData.fileId
              this.detailForm.isLongValid
              this.detailForm.isLongValid === 1
                ? (this.detailForm.licenceEndTime = '长期有效')
                : ''

              this.onSend()
            }
          } else {
            if (!this.file.data) {
              this.onSend()
            } else {
              let form = new FormData()
              form.append('file', this.file.data)
              let fileData = await this.$api.common.fileUpload(form)
              this.detailForm.fileId = fileData.fileId
              this.onSend()
            }
          }
        }
      })
    },
    async onSend() {
      this.detailForm.licenceEndTime =
        this.detailForm.isLongValid === 1
          ? null
          : this.detailForm.licenceEndTime
      this.detailForm.licenceEndTime =
        this.detailForm.isLongValid === 1
          ? null
          : this.detailForm.licenceEndTime
      if (this.pageType === 'create') {
        let params = this.detailForm
        let data = await this.$api.licence.createLicence(params)
        if (data) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.onCancel()
        }
      } else {
        let params = this.detailForm
        let data = await this.$api.licence.updateLicence(params)
        if (data) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.onCancel()
        }
      }
    },
    onCancel() {
      this.$router.push({
        name: 'MyLicence'
      })
    }
  }
}
</script>
<style lang="less">
.licence-detail {
  margin-bottom: 30px;
  .upload-tip {
    display: flex;
    dt {
      margin-right: 10px;
      font-weight: bold;
    }
    dd {
      display: inline-block;
      margin-right: 10px;
    }
  }
  .file-preview {
    margin-top: 15px;
  }
  .button-group {
    margin-top: 60px;
    text-align: center;
  }
  &.page-create,
  &.page-update {
    .form-item-text {
      display: none;
    }
  }
  &.page-check {
    .el-select,
    .el-input,
    .el-textarea,
    .el-radio-group,
    .el-checkbox,
    .el-upload,
    .el-upload__tip {
      display: none;
      margin-left: 10px;
    }
  }
  img {
    max-width: 100%;
  }
  .el-button {
    font-size: 15px;
    padding: 8px 15px;
  }
}
</style>
